const ameblo = window.ameblo = window.ameblo || {};
const content = ameblo.content = {};
const ua = window.navigator.userAgent;

content.ua = {
  isApp: /cawebapp.*jpameblo/i.test(ua)
};

if(content.ua.isApp) {
  document.querySelector('.ambHeader').classList.add('is-hide');
  document.querySelector('.ambFooter').classList.add('is-hide');
}
